import React from 'react';
import { useLingui } from '@lingui/react/macro';

import { PopoverPlacement } from '@rover/components/src/callouts/Popover/popover.constants';
import {
  AVATAR_BADGE_SIZES,
  AVATAR_SIZES,
  SEARCH_RESULT_CARD_Z_INDEX,
} from '@rover/components/src/cards/SearchResultCard/SearchResultCard.constants';
import { Box } from '@rover/kibble/core';
import Avatar from '@rover/kibble/patterns/Avatar';
import Badge from '@rover/react-lib/src/pages/search/shared/components/SitterBadge';
import type { SitterBadge } from '@rover/types/src/SitterBadge';

type Props = {
  imageUrl: Record<'small' | 'medium', string>;
  badge?: SitterBadge;
  shortName: string;
  description?: string;
};

const AvatarWithBadge: React.FC<Props> = ({ imageUrl, badge, shortName, description }) => {
  const { t } = useLingui();
  const altDescription = t`Sitter Profile Image: ${shortName}`;
  return (
    <Box position="relative" minWidth={AVATAR_SIZES.REDUCED}>
      <meta itemProp="image" content={imageUrl.medium} />
      <Avatar
        imageUrl={imageUrl.small}
        alt={description || altDescription}
        width={AVATAR_SIZES.REDUCED}
        height={AVATAR_SIZES.REDUCED}
      />

      {badge && (
        <Box
          position="absolute"
          bottom="0"
          right="0"
          width={AVATAR_BADGE_SIZES.REDUCED}
          height={AVATAR_BADGE_SIZES.REDUCED}
          zIndex={`${SEARCH_RESULT_CARD_Z_INDEX.INTERACTIVE}`}
        >
          <Badge
            title={badge.title}
            content={badge.content}
            imageUrl={badge.imageUrl}
            key={badge.imageUrl}
            slug={badge.slug}
            width={AVATAR_BADGE_SIZES.REDUCED}
            popoverPlacement={PopoverPlacement.RIGHT}
            itemProp="hasCredential"
          />
        </Box>
      )}
    </Box>
  );
};

export default AvatarWithBadge;
